import { t } from '@lingui/macro';
import { Button } from '../../../../shared/view/components/Button/Button';

export type InjectionCountSummaryViewProps = {
  dosage: string | null;
  displayCount: number | null;
  maxCount: number;
  onModify: () => void;
  onNext: () => void;
};

export const InjectionCountSummaryView = ({
  dosage,
  displayCount,
  maxCount,
  onModify,
  onNext,
}: InjectionCountSummaryViewProps) => (
  <div className="flex flex-col flex-grow w-full">
    <h1 className="font-sans-ext text-grey-0 text-title-l font-semibold pb-24 leading-tight">
      {t`checkin.injection-count.summary.title`}
      <br />
      {t`checkin.injection-count.summary.subtitle`}
    </h1>

    <div className="bg-grey-800 rounded-2xl p-16">
      <div className="flex items-center gap-8 pb-12">
        <span className="text-green-500 text-p1 font-semibold">{'✅'}</span>
        <span className="text-grey-0 text-p1 font-semibold">
          {t`checkin.injection-count.summary.recorded`}
        </span>
      </div>
      <p className="text-grey-300 text-p2">
        {dosage && (
          <>
            <span>{dosage}</span>
            <span className="px-8">&middot;</span>
          </>
        )}
        <span>
          {t`checkin.injection-count.summary.progress ${displayCount} ${maxCount}`}
        </span>
        <button
          type="button"
          onClick={onModify}
          className="pl-12 text-grey-100 underline"
        >
          {t`checkin.injection-count.summary.modify`}
        </button>
      </p>
    </div>

    <div className="w-full fixed max-w-[535px] bottom-16 px-16 left-0 right-0 mx-auto">
      <Button.Primary
        className="w-full font-semibold"
        onClick={onNext}
        label={t`cta.next`}
      />
    </div>
  </div>
);
